import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { logOut as reduxLogout } from "@redux/slice.auth";

function useAxiosLogout() {
  const dispatch = useDispatch();

  const logOut = useCallback(() => {
    if (window.webkit?.messageHandlers?.authLogout) {
      window.webkit.messageHandlers.authLogout.postMessage({});
    }

    dispatch(reduxLogout());
  }, [dispatch]);

  return { logOut };
}

export default useAxiosLogout;